import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { BaseTransformer } from './BaseTransformer';
export var CrmDealTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(CrmDealTransformer, _BaseTransformer);
  var _super = _createSuper(CrmDealTransformer);
  function CrmDealTransformer() {
    _classCallCheck(this, CrmDealTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(CrmDealTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      var tags_TEXT = "";
      var tagsValues = [];
      if (data.tags && data.tags[0]) {
        var tagsLabels = [];
        data.tags.forEach(function (k) {
          tagsLabels.push(k.label);
          tagsValues.push(k.value);
        });
        tags_TEXT = tagsLabels.join(",");
      }
      var followers = [];
      if (data.followers && data.followers[0] && data.followers[0].id) {
        followers = data.followers.map(function (k) {
          return k.id ? parseInt(k.id.substr(1)) : null;
        });
      }
      return {
        subjectTable: {
          subject: data.subject,
          accountName: data.account_name ? data.account_name : {
            value: 0,
            label: ''
          }
        },
        priceTable: {
          title: data.expected_revenue ? data.expected_revenue.currency + ' ' + data.expected_revenue.value : null
        },
        subject: data.subject,
        type: data.type && data.type.value,
        typeLabel: data.type && data.type.label,
        accountName: data.account_name ? data.account_name : {
          value: 0,
          label: ''
        },
        contact: data.contact_name ? data.contact_name : {
          value: 0,
          label: ''
        },
        contactName: data.contact_name && data.contact_name.value ? data.contact_name.value : 0,
        contactNameLabel: data.contact_name && data.contact_name.label ? data.contact_name.label : '!!',
        // potentialName: data.potential_name && data.potential_name.value,
        expectedRevenue: data.expected_revenue ? data.expected_revenue.value : 0,
        expectedRevenueCur: data.expected_revenue ? data.expected_revenue.currency : null,
        tags: tagsValues,
        lead: data.lead,
        tags_TEXT: tags_TEXT,
        leadSource: data.lead_source && data.lead_source.value,
        hotProspect: data.hot_prospect == 1 ? true : false,
        relatedData: data.relatedData,
        recordOwner: data.record_owner ? data.record_owner.value : null,
        recordOwnerLabel: data.record_owner ? data.record_owner.label : null,
        closingNotes: data.closing_notes,
        closedReason: data.closed_reason && data.closed_reason.value ? data.closed_reason.value : data.closed_reason,
        closedReasonLabel: data.closed_reason && data.closed_reason.label,
        followers: followers,
        followUpOn: data.follow_up_on,
        expectedClosingDate: data.expected_closing_date,
        tableStage: {
          stageLabel: data.stage && data.stage.label,
          stageColor: data.stage && data.stage.color ? data.stage.color : data.relatedData && data.relatedData.stage && data.relatedData.stage.color ? data.relatedData.stage.color : 'aaa'
        },
        labelsData: data.labels_data,
        labelsDataLabel: this.getLabelsLabel(data.labels_data),
        stageLabel: data.stage && data.stage.label,
        stageColor: data.stage && data.stage.color ? data.stage.color : data.relatedData && data.relatedData.stage && data.relatedData.stage.color ? data.relatedData.stage.color : 'aaa',
        description: data.description,
        lastActivityNotes: data.last_activity_notes,
        lastActivityType: data.last_activity_type,
        lastActivityDate: data.last_activity_date,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by,
        recordId: data.record_id
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      if (data.stage != 6 && data.stage != 7) {
        data.closingNotes = '';
        data.closedReason = '';
      }
      var followers = "";
      if (data.followers && data.followers[0]) {
        var arr = data.followers.map(function (k) {
          return 'U' + k;
        });
        followers = arr && arr[0] ? arr.join(",") : '';
      }
      return {
        type: data.type && data.type.value ? data.type.value : data.type,
        account_name: data.accountName && data.accountName.value,
        contact_name: data.contactName && data.contactName.value ? data.contactName.value : data.contactName,
        expected_revenue: data.expectedRevenue,
        expected_revenue__cur: data.expectedRevenueCur,
        subject: data.subject,
        tags: data.tags,
        lead_source: data.leadSource,
        hot_prospect: data.hotProspect,
        lead: data.lead,
        record_owner: data.recordOwner,
        // followers: data.followers,
        followers: followers,
        follow_up_on: data.followUpOn,
        expected_closing_date: data.expectedClosingDate,
        stage: data.stage && data.stage.value ? data.stage.value : data.stage ? data.stage : 1,
        description: data.description,
        closing_notes: data.closingNotes,
        closed_reason: data.closedReason,
        // last_activity_notes: data.lastActivityNotes,
        // last_activity_type: data.lastActivityType,
        // last_activity_date: data.lastActivityDate,
        // created_on: data.createdOn,
        // created_by: data.createdBy,
        // last_modified_on: data.lastModifiedOn,
        // last_modified_by: data.lastModifiedBy,
        record_id: data.recordId
      };
    }
  }, {
    key: "getLabelsLabel",
    value: function getLabelsLabel(data) {
      var add = "";
      var vg = "";
      if (data && data[0]) {
        data.forEach(function (k) {
          add += vg + k.label;
          vg = ", ";
        });
      }
      return add;
    }
  }]);
  return CrmDealTransformer;
}(BaseTransformer);